var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mypagePage"},[_c('Top',{attrs:{"isLogin":_vm.isLogin,"myInfo":_vm.myInfo,"dashboardData":_vm.dashboardData}}),_c('div',{staticClass:"container",attrs:{"id":"scrollAnchor"}},[_c('router-view',{staticClass:"content",attrs:{"isLogin":_vm.isLogin,"reserveData":_vm.reserve}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }